export enum InterviewTab {
  NOTES = "notes",
  TRANSCRIPT = "transcript",
  EVALUATION = "evaluation",
  SIGNALS = "signals",
  ASSIST = "assist",
  CLIPS = "clips",
}

export const isMainTab = (
  s: string,
  isSmallScreen: boolean,
  signalsEnabled: boolean
): s is InterviewTab => {
  const tabs = [InterviewTab.EVALUATION, InterviewTab.TRANSCRIPT];
  if (signalsEnabled) {
    tabs.push(InterviewTab.SIGNALS);
  }
  if (isSmallScreen) {
    tabs.push(InterviewTab.NOTES);
    tabs.push(InterviewTab.ASSIST);
  }
  return tabs.includes(s as any);
};

export const isSidebarTab = (s: string): s is InterviewTab =>
  [InterviewTab.ASSIST, InterviewTab.NOTES, InterviewTab.CLIPS].includes(
    s as any
  );
